function IconTalkTimeAvgFace() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7451 0 0 10.7451 0 24C0 37.2549 10.7451 48 24 48C37.2549 48 48 37.2549 48 24C48 10.7451 37.2549 0 24 0M38.5923 34.6286C36.5095 36.7217 31.8449 40.236 24.0003 40.236C16.1541 40.236 11.4895 36.7217 9.40662 34.6286C8.55462 33.7697 8.55805 32.3828 9.41691 31.5308C10.2741 30.6771 11.6609 30.6806 12.5146 31.5394C14.4723 33.5074 18.0535 35.8543 24.0003 35.8543C29.9472 35.8543 33.5283 33.5074 35.4861 31.5394C36.3381 30.6806 37.7249 30.6771 38.5838 31.5308C39.4409 32.3828 39.4461 33.7697 38.5923 34.6286M16.4311 15.6377C18.7986 15.6377 20.7186 17.556 20.7186 19.9234C20.7186 22.2908 18.7986 24.2091 16.4311 24.2091C14.0654 24.2091 12.1471 22.2908 12.1471 19.9234C12.1471 17.556 14.0654 15.6377 16.4311 15.6377M31.8595 15.6377C34.2269 15.6377 36.1469 17.556 36.1469 19.9234C36.1469 22.2908 34.2269 24.2091 31.8595 24.2091C29.4938 24.2091 27.5755 22.2908 27.5755 19.9234C27.5755 17.556 29.4938 15.6377 31.8595 15.6377"
        fill="white"
      />
    </svg>
  );
}

export { IconTalkTimeAvgFace };
